import axios from "axios";
import backendUrl from "./apiUrl";

const axiosClient = axios.create({
  baseURL: backendUrl,
  responseType: "json",
});

export default axiosClient;
